import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';
import 'draft-js/dist/Draft.css';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';

import { CustomFormLabel } from '../../customComponent';

import useUser from '../../../hook/useUser';
import useGlobalStatus from '../../../hook/useGlobalStatus';
import useColorSystem from '../../../hook/useColorSystem';

import * as urlConstants from '../../../constants/url';

import {
  HelpOutlineIcon,
  CheckBoxOutlineBlankIcon,
  CheckBoxIcon,
  HighlightOffOutlinedIcon,
  KeyboardArrowDownOutlinedIcon,
} from '../../../constants/images';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const FbCampaignData = (props) => {
  const {
    selectedAdAccounts,
    campaignList,
    setCampaignList,
    selectedCampaign,
    setSelectedCampaign,
    fetchCampaignData,
    setModalName,
    setIsLoading,
    scrollToAnchor,
  } = props;

  const history = useHistory();
  const intl = useIntl();
  const { userData, setUserData, setAuthStatusMsg, setAlertMsg } = useUser();
  const { currentActiveData, locale, setLocale, entryPath, setModalContent, setIsModalOpen } = useGlobalStatus();
  const [allCampaignChecked, setAllCampaignChecked] = useState(false);
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();

  //選擇全部廣告活動
  useEffect(() => {
    if (campaignList.length !== 0 && selectedCampaign.length === campaignList.length) {
      setAllCampaignChecked(true);
    } else {
      setAllCampaignChecked(false);
    }
  }, [selectedCampaign])

  //選擇全部廣告活動
  const changeAllCampaign = (e) => {
    const { checked } = e.target;
    if (checked === true) {
      setAllCampaignChecked(true);
      setSelectedCampaign(campaignList);
    } else {
      setAllCampaignChecked(false);
      setSelectedCampaign([]);
    }
  }

  return (
    <Box mb={5}>
      <Box
        mt={2}
        sx={{ width: '100%' }}
      >
        <Stack variant='between-center'>
          <CustomFormLabel>
            <FormattedMessage id="createData.campaign.campaign" values={{ campaign: "行銷活動" }} />
            <Tooltip title={<FormattedMessage id="createData.campaign.tip.facebook" />}>
              <HelpOutlineIcon variant="dark" />
            </Tooltip>
          </CustomFormLabel>
          {selectedAdAccounts.length > 0 && entryPath === urlConstants.PAGE_FB_CREATE_DATA &&
            <Typography
              sx={{
                cursor: 'pointer',
                p: 0,
                marginBottom: '8px',
                color: mainColor
              }}
              onClick={() => fetchCampaignData('create')}
            >
              <FormattedMessage id="createData.campaign.import" values={{ campaign: "行銷活動" }} />
            </Typography>
          }
        </Stack>

        <Autocomplete
          multiple
          size="small"
          id="selectCampaign"
          options={campaignList}
          groupBy={(option) => option.cidname}
          disableCloseOnSelect={campaignList.length > 1 ? true : false}
          disableClearable={true}
          noOptionsText={<FormattedMessage id="createData.campaign.noOptionsText" values={{ campaign: "行銷活動" }} />}
          value={selectedCampaign}
          getOptionLabel={(option) => option.name}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
                color={colorMedia}
              />
              {option.name}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              color={colorMedia}
              placeholder={intl.formatMessage(
                { id: "createData.campaign.placeholder" },
                { campaign: "行銷活動" }
              )}
            />
          )}
          onChange={(event, newValue) => {
            setSelectedCampaign(newValue);
          }}
          ChipProps={{
            deleteIcon: <HighlightOffOutlinedIcon />
          }}
          popupIcon={<KeyboardArrowDownOutlinedIcon />}
        />
        {
          <CustomFormLabel
            sx={{
              display: 'inline-block',
              mt: '2px',
              cursor: 'pointer',
            }}
            onClick={() => {
              setSelectedCampaign(campaignList)
            }}
          >
            <Checkbox
              size="small"
              name="allCampaign"
              color={colorMedia}
              checked={allCampaignChecked}
              onChange={changeAllCampaign}
              disabled={campaignList.length > 0 ? false : true}
            />
            <FormattedMessage id="createData.campaign.allCampaign" values={{ campaign: "行銷活動" }} />
          </CustomFormLabel>
        }
      </Box>
    </Box>
  )
}

export default FbCampaignData;